import SearchIcon from "../../assets/search.svg";
import FilterIcon from "../../assets/filter.svg";
import styles from "./Search.module.css";

const Search = ({ openFilter, setOpenFilter, setApiRequest }) => {
  const showFilter = () => {
    setOpenFilter(!openFilter);
  };

  let timeOut;
  const searchChange = (e) => {
    clearTimeout(timeOut);
    timeOut = setTimeout(() => {
      setApiRequest((prev) => ({
        ...prev,
        searchtext: e.target.value
      }))
    }, 1000);
  }

  return (
    <div className={styles.searchContainer}>
      <div className={styles.searchImage}>
        <img src={SearchIcon} alt="search icon" />
      </div>
      <div className={styles.searchInput}>
        <input type="text" placeholder="Places, Events and Activities" onChange={(e) => searchChange(e)} onClick={() => setOpenFilter(false)} />
      </div>
      <div className={styles.filterImage} onClick={showFilter}>
        <img src={FilterIcon} alt="filter icon" />
      </div>
    </div>
  );
};

export default Search;
